import firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyD6CGwiIs4ySPPnIfvWekeObyksSMfEpEk",
    authDomain: "smartbell-master.firebaseapp.com",
    databaseURL: "https://smartbell-master.firebaseio.com",
    projectId: "smartbell-master",
    storageBucket: "smartbell-master.appspot.com",
    messagingSenderId: "821508912027",
    appId: "1:821508912027:web:c4e265d7b67c3da6abe73e"
};

firebase.initializeApp(firebaseConfig);

export default {
    firestore: firebase.firestore(),
    auth: firebase.auth(),
}